import { useEffect, useState } from "react";
import { getCompanysApi } from "../api/company.js";
export function useAllCompany() {
    const [allCompany, setAllCompany] = useState();
    const token = window.localStorage.getItem("token");

    useEffect(() => {
        if (token) {
            getAllCompany();
        }
    }, [token]);

    const getAllCompany = async () => {
        const response = await getCompanysApi();
        if (response?.data) {
            setAllCompany(response.data);
        } else {
            setAllCompany("Token Expired");
        }
    };

    return allCompany;
}
